import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import { FeriasService } from "../../../services/FeriasService";
import { FeriasCivilService } from "../../../services/FeriasCivilService";
import { FeriasEscolaresService } from "../../../services/FeriasEscolaresService";
import { SolicitarFeriasService } from "../../../services/SolicitarFeriasService";
import moment from "moment";
import { date, strtotime } from "date-typescript-library";
import { SnackBarModule } from "../../../modules/SnackBarModule";

export default {
    name: "DefinirFeriasEscolares",

    components: {
        AutocompleteField,
        SelectField,
        PeriodoField,
        TextField
    },

    data: () => ({
        unidade: null,
        lotacao: null,
        exercicio: false,
        exercicioTemp: false,
        militares: [],
        militaresTemp: [],
        graduacao: null,
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
        diasRestantes: 0,
        disabledLotacao: true,
        loadingButton: false,
        tableUsers: [
            { text: "Usuário", value: "nome", sortable: false },
            { text: "", value: "atribuir", sortable: false, width: "100" },
        ],
        users: [],
        search: "",
        page: 1,
        pageCount: 0,
        optionsFilter: {
            unidade: null,
            lotacao: null,
            exercicio: null,
            graduacao: null,
            dataInicio: null,
            dataFim: null,
            militares: null
        },
    }),

    computed: {
        disabledMilitares() {
            return !this.exercicio || !this.graduacao || !this.lotacao || !this.unidade;
        }
    },

    mounted() {
        this.getUnidadeItems();
        this.getGraduacaoItems();
        this.getExercicioItems();
    },

    watch: {

        unidade: async function (unidade) {
            if (unidade) {
                this.getLotacoesItems(unidade);
            } else {
                this.disabledLotacao = true;
                this.unidade = null;
            }
            this.lotacao = null;
            this.militares = [];
        },

        lotacao: async function (lotacao) {
            if (lotacao) {
                this.getMilitaresItems();
            } else {
                this.lotacao = null;
            }
        },

        exercicio: async function (exercicio) {

            if (this.exercicioTemp) {
                this.militares = [];
            }
            if (exercicio) {
                this.exercicioTemp = this.exercicio
            } else {
                this.exercicioTemp = null
            }

            this.getMilitaresItems();
        },

        graduacao: async function () {
            this.militares = [];
            this.getMilitaresItems();
        },

    },

    methods: {
        async getUnidadeItems() {
            const response = await FeriasService.getUnidade();
            this.optionsFilter.unidade = response.map((el) => {
                return {
                    text: el.nome_abreviado,
                    value: el.id,
                };
            });
            this.optionsFilter.unidade?.unshift({
                text: "Selecione",
                value: "",
            });
        },

        async getLotacoesItems(unidade) {
            const response = await FeriasService.getLotacaoByUnidade(unidade);

            this.optionsFilter.lotacao = response.map((el) => {
                return {
                    text: el.nome,
                    value: el.id,
                };
            });
            this.optionsFilter.lotacao?.unshift({
                text: "Selecione",
                value: "",
            });

            this.disabledLotacao = false;
        },

        async getGraduacaoItems() {
            const response = await FeriasCivilService.getGraduacao();

            this.optionsFilter.graduacao = response.map((el) => {
                return {
                    text: el.descricao,
                    value: el.id,
                };
            });
            this.optionsFilter.graduacao?.unshift({
                text: "Selecione",
                value: "",
            });
        },

        async getExercicioItems() {
            const response = await FeriasService.getExerciciosEscolares();
            this.optionsFilter.exercicio = response.map((el) => {
                return {
                    text: el.exercicio,
                    value: el.exercicio,
                };
            });
            this.optionsFilter.exercicio?.unshift({ text: "Selecione", value: "" });
        },

        async getMilitaresItems() {

            if (!this.lotacao) {
                return
            }

            const filter = this.prepareFormFilter();
            const response = await FeriasEscolaresService.listaMilitaresEmCurso(filter);

            this.optionsFilter.militares = response.map((el) => {
                return {
                    text: el.nome,
                    value: el.id + ':' + el.exercicio,
                };
            });
            this.optionsFilter.militares?.unshift({ text: "Selecione", value: "" });
        },

        async calculateDays() {

            if (this.dataInicio) {
                const formData = new FormData();
                formData.append("data_ini", moment(this.dataInicio).format("YYYY-MM-DD"));
                formData.append("dias", this.numeroDias);
                const response = await SolicitarFeriasService.calcularDiasUteis(formData);
                this.dataFim = response.dataFim;
                this.numeroDias = response.dias_uteis;
                const doisMeses = date("Y-m-d", strtotime("+ 2 MONTHS"));
                this.confirmDialog = doisMeses > moment(this.dataInicio).format("YYYY-MM-DD")

                return this.calcularTotalDiasRestantes();
            }
            return SnackBarModule("Prencha o campo de data inicial", "error");
        },

        calcularTotalDiasRestantes() {
            this.diasRestantes = 25;

            this.diasRestantes = this.diasRestantes - parseInt(this.numeroDias)
            if (this.diasRestantes < 0) {
                return SnackBarModule("Número de dias dos períodos solicitados juntos devem ser menor que 25", "error");
            }
            return;
        },

        prepareForm() {
            this.loadingButton = true;
            const formData = new FormData();
            let form = true;

            const usuarios = [];
            const exercicios = [];

            if (!this.militares.length) {
                form = false
                this.loadingButton = false;
                SnackBarModule("É necessário informar o(s) militar(s).", "error");
                return;
            }

            this.militares.forEach(item => {
                const [usuario] = item.split(':');
                usuarios.push(parseInt(usuario));
                exercicios.push(parseInt(this.exercicio));
            });

            const exerciciosDiferentes = new Set(exercicios).size !== 1;

            if (exerciciosDiferentes) {
                this.militares = [];
                this.loadingButton = false;
                return SnackBarModule("Os exercícios precisam ser iguais.", "error");
            } else {
                this.exercicio = exercicios[0];
            }

            if (this.dataInicio == null || this.dataFim == null) {
                form = false
                this.loadingButton = false;
                SnackBarModule("Datas de início e fim devem ser informadas.", "error");
                return;
            }

            if (this.numeroDias == null) {
                form = false
                this.loadingButton = false;
                SnackBarModule("Número de dias precisa ser informado(s)s.", "error");
                return;
            }

            if (this.numeroDias > this.saldoFerias) {
                form = false
                this.loadingButton = false;
                SnackBarModule("Saldo insuficiente", "error");
                return;
            }

            if (this.numeroDias == 0) {
                form = false
                this.loadingButton = false;
                SnackBarModule("O número de dias deve ser maior que zero", "error");
                return;
            }

            if (this.militares == []) {
                form = false
                this.loadingButton = false;
                SnackBarModule("Selecione um ou mais militares", "error");
                return;
            }

            this.militaresTemp = this.militares;
            this.militares = usuarios;
            this.militares.forEach((element, index) => {
                formData.append(`validaPreCadastro`, true)
                formData.append(`feriasEscolares[${index}][exercicio]`, this.exercicio)
                formData.append(`feriasEscolares[${index}][data_ini]`, this.dataInicio)
                formData.append(`feriasEscolares[${index}][data_fin]`, this.dataFim)
                formData.append(`feriasEscolares[${index}][dias]`, this.numeroDias)
                formData.append(`feriasEscolares[${index}][id_sigrh]`, element)
            });


            if (form) {
                this.sendForm(formData);
                return;
            }
        },

        async sendForm(formData) {
            const response = await FeriasEscolaresService.agendarFeriasEscolares(formData);
            if (response) {
                this.$emit('on-confirm');
                this.close();
            } else {
                this.militares = this.militaresTemp;
            }
            this.loadingButton = false;
        },

        prepareFormFilter() {
            const filter = new FormData();
            this.graduacao
                ? filter.append("id_graduacao", this.graduacao)
                : null;
            this.unidade
                ? filter.append("id_unidade", this.unidade)
                : null;
            this.lotacao
                ? filter.append("id_lotacao", this.lotacao)
                : null;
            this.exercicio
                ? filter.append("exercicio", this.exercicio)
                : null;
            return filter;
        },

        clearForm() {
            this.unidade = null;
            this.lotacao = null;
            this.exercicio = null;
            this.militares = [];
            this.militaresTemp = [];
            this.graduacao = null;
            this.dataInicio = null;
            this.dataFim = null;
            this.numeroDias = null;
            this.diasRestantes = 0;
            this.disabledLotacao = true;
        },

        close() {
            this.clearForm();
            this.$emit("on-close");
        },
    }
};